/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Staff_No_DataInputs */

const vi_report_staff_no_data = /** @type {(inputs: Report_Staff_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có dữ liệu`)
};

/**

* @param {Report_Staff_No_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_staff_no_data = /** @type {((inputs?: Report_Staff_No_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Staff_No_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_staff_no_data(inputs)
});